import { SweetAlertService } from './../../../../core/services/utils/sweet-alert.service';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { Component, OnInit } from '@angular/core';
import { LocalService } from 'src/app/core/services/storage/local.service';

@Component({
  selector: 'app-modal-pausa',
  templateUrl: './modal-pausa.component.html',
  styleUrls: ['./modal-pausa.component.css']
})
export class ModalPausaComponent implements OnInit {
  ejecutivo = localStorage.getItem('ejecutivo');

  constructor(
    private modalService: ModalService,
    private emit: EmitService,
    private localService: LocalService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
  }

  finPausa(accion:string){
    try {
      if(!this.localService.getValue('consultora')) {
        this.sweetAlertService.swalClose();
        this.sweetAlertService.swalInternet();
        return;
      }

      this.modalService.closeModal();
      this.sweetAlertService.swalLoading();
      this.localService.setValue('pausado', false);
      this.emit.enviarData(accion);
    } catch(error) {
      //la variable localstorage no existe
      this.modalService.closeModal();
      this.sweetAlertService.swalLoading();
      this.localService.setValue('pausado', false);
      this.emit.enviarData(accion);
    }
  }

}
